/* eslint-disable no-restricted-globals */
import { useEffect, useCallback, useRef } from "react";
import { useRefsContext } from "@/contexts/ref";
import { useTrackingScroll } from "./useTrackingScroll";
const TRACKED_SECTIONS = [
    "price",
    "location",
    "mortgage_calculator",
];
export const useTrackingSectionScroll = () => {
    const context = useRefsContext();
    const trackedSectionsRef = useRef(new Set());
    const trackPriceScroll = useTrackingScroll("price");
    const trackLocationScroll = useTrackingScroll("location");
    const trackMortgageCalculatorScroll = useTrackingScroll("mortgage_calculator");
    const getRefName = (sectionName) => {
        switch (sectionName) {
            case "mortgage_calculator":
                return "mortgageSection";
            default:
                return sectionName;
        }
    };
    const getTrackingFunction = useCallback((sectionName) => {
        switch (sectionName) {
            case "price":
                return trackPriceScroll;
            case "location":
                return trackLocationScroll;
            case "mortgage_calculator":
                return trackMortgageCalculatorScroll;
            default:
                return () => { };
        }
    }, [trackPriceScroll, trackLocationScroll, trackMortgageCalculatorScroll]);
    const isElementFullyVisible = useCallback((element) => {
        if (!element)
            return false;
        const rect = element.getBoundingClientRect();
        return (rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= window.innerHeight &&
            rect.right <= window.innerWidth);
    }, []);
    const getSectionElement = useCallback((sectionName) => {
        const refName = getRefName(sectionName);
        const refKey = `${refName}Ref`;
        const sectionRef = context[refKey];
        if (sectionRef &&
            "current" in sectionRef &&
            sectionRef.current instanceof HTMLElement) {
            return sectionRef.current;
        }
        return null;
    }, [context]);
    useEffect(() => {
        const handleScroll = () => {
            TRACKED_SECTIONS.forEach((sectionName) => {
                const element = getSectionElement(sectionName);
                if (isElementFullyVisible(element) &&
                    !trackedSectionsRef.current.has(sectionName)) {
                    trackedSectionsRef.current.add(sectionName);
                    const trackingFunction = getTrackingFunction(sectionName);
                    trackingFunction();
                }
            });
        };
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [isElementFullyVisible, getSectionElement, getTrackingFunction]);
};
